import { Component, OnInit, inject } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { IActivo } from 'modelos/src';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HelperService } from '../../../../../../auxiliares/servicios/helper.service';
import { TriperoService } from '../../../../../../auxiliares/servicios/http/tripero.service';

@Component({
  selector: 'app-setear-odometro',
  templateUrl: './setear-odometro.component.html',
  styleUrls: ['./setear-odometro.component.scss'],
  standalone: false,
})
export class SetearOdometroComponent implements OnInit {
  data = inject<IActivo>(MAT_DIALOG_DATA);
  private fb = inject(UntypedFormBuilder);
  private dialogRef = inject<MatDialogRef<SetearOdometroComponent>>(MatDialogRef);
  private service = inject(TriperoService);
  private helper = inject(HelperService);

  public loading = true;

  public formulario?: UntypedFormGroup;

  private createForm(): void {
    this.formulario = this.fb.group({
      totalDistance: [null, Validators.required],
    });
  }

  public close(): void {
    this.dialogRef.close();
  }

  public async enviar(): Promise<void> {
    // El odómetro es del VEHÍCULO, así que se identifica con su `_id` — el
    // mismo que usan /trips, /stops y /status. Antes se mandaba el `uniqueId`
    // del tracker, que es lo que Tripero usaba como clave hasta la migración.
    if (!this.data?._id) {
      this.helper.notifError('No se pudo identificar el vehículo');
      return;
    }

    this.loading = true;
    try {
      // Convertir km a metros
      const odometerMeters = this.formulario?.value.totalDistance * 1000;
      await this.service.setOdometer({
        idVehiculo: this.data._id,
        initialOdometer: odometerMeters,
        reason: 'Configuración manual desde panel',
      });
      this.helper.notifSuccess('Odómetro configurado correctamente');
      this.dialogRef.close(true);
    } catch (err) {
      console.error(err);
      this.helper.notifError(err);
    }
    this.loading = false;
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.createForm();
    this.loading = false;
  }
}
